import { ApolloError } from '@apollo/client';
import { GraphQLFormattedError } from 'graphql';

import { ClientLogger } from '../client-logger';
import { SEVERITY } from '../../toast/Toast';

const DEBUG = false;

export interface ErrorData {
  apolloErrors?: ApolloError;
  graphQLErrors?: ReadonlyArray<GraphQLFormattedError>;
  errors?: string[];
  error?: any;
}

export class ErrorFormatter {
  constructor(public readonly errorData: ErrorData) {}
  public displayErrors(): string {
    const errors: (string | null | undefined)[] = [];
    this.errorData.errors?.forEach((e) => errors.push(ClientLogger.errorToText(e)));
    this.errorData.graphQLErrors?.forEach((e) => errors.push(JSON.stringify(e.message)));
    if (this.errorData.apolloErrors) {
      errors.push(ClientLogger.errorToText(this.errorData.apolloErrors));
    }
    if (this.errorData.error) {
      errors.push(ClientLogger.errorToText(this.errorData.error));
    }
    DEBUG && ClientLogger.debug('ErrorFormatter', 'displayErrors', { errorData: this.errorData, errors });
    return errors.join(', ');
  }

  public toastAndLogError(
    toastDispatch: (params: { msg: string; severity: SEVERITY; autoClose?: boolean }) => void,
    location: string,
    whenAttempting: string
  ) {
    if (!this.errorData.errors) {
      this.errorData.errors = [];
    }
    const newMessage = `Error ${whenAttempting} in module ${location}`;
    this.errorData.errors.push(newMessage);
    let msg = this.displayErrors();
    ClientLogger.error(location, msg);
    msg = this.displayErrors();

    toastDispatch({ msg, severity: SEVERITY.ERROR, autoClose: true });
  }
}
